import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListMedicinePresentationTypeResponse } from '../../responses/pharmacy/list-medicine-presentation-type.response';

@Injectable({
  providedIn: 'root'
})
export class MedicinePresentationTypeService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listMedicinePresentationType(): Observable<ListMedicinePresentationTypeResponse>{
    let uri = `MedicinePresentationType/`;

    return this.httpClient.get<ListMedicinePresentationTypeResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}